module.exports = __webpack_public_path__ + "img/51.d4f39ff3.jpg";